import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const UploadDoc = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="upload document icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={`color-iconBrand-default ${pathClass}`}
      d="M16.5607 1.31802C17.4046 0.474104 18.5492 0 19.7426 0H43.5C45.9853 0 48 2.01472 48 4.5V39.5H45V4.5C45 3.67157 44.3284 3 43.5 3H19.7426C19.3448 3 18.9633 3.15803 18.682 3.43934L10.4393 11.682C10.158 11.9633 10 12.3448 10 12.7426V54.5C10 55.3284 10.6716 56 11.5 56H36.5V59H11.5C9.01472 59 7 56.9853 7 54.5V12.7426C7 11.5492 7.47411 10.4046 8.31802 9.56066L16.5607 1.31802Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 10V1.5H20V11.5C20 12.3284 19.3284 13 18.5 13H8.5V10H17Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 47.5C15 46.6716 15.6716 46 16.5 46H27C27.8284 46 28.5 46.6716 28.5 47.5C28.5 48.3284 27.8284 49 27 49H16.5C15.6716 49 15 48.3284 15 47.5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 40.5C15 39.6716 15.6716 39 16.5 39H27C27.8284 39 28.5 39.6716 28.5 40.5C28.5 41.3284 27.8284 42 27 42H16.5C15.6716 42 15 41.3284 15 40.5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 33.5C15 32.6716 15.6716 32 16.5 32H38.5C39.3284 32 40 32.6716 40 33.5C40 34.3284 39.3284 35 38.5 35H16.5C15.6716 35 15 34.3284 15 33.5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 26.5C15 25.6716 15.6716 25 16.5 25H38.5C39.3284 25 40 25.6716 40 26.5C40 27.3284 39.3284 28 38.5 28H16.5C15.6716 28 15 27.3284 15 26.5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 19.5C15 18.6716 15.6716 18 16.5 18H38.5C39.3284 18 40 18.6716 40 19.5C40 20.3284 39.3284 21 38.5 21H16.5C15.6716 21 15 20.3284 15 19.5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46 61C51.5228 61 56 56.5228 56 51C56 45.4772 51.5228 41 46 41C40.4772 41 36 45.4772 36 51C36 56.5228 40.4772 61 46 61ZM46 64C53.1797 64 59 58.1797 59 51C59 43.8203 53.1797 38 46 38C38.8203 38 33 43.8203 33 51C33 58.1797 38.8203 64 46 64Z"
    />
    <circle
      className={`color-iconPrimary-disabled ${pathClass}`}
      cx="46"
      cy="51"
      r="10"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      d="M49.1806 49.6128C49.3892 49.612 49.5836 49.6928 49.7283 49.8391L49.7973 49.9088C49.9332 50.0458 50.0086 50.2291 50.0086 50.4217C50.0086 50.6231 49.9272 50.8117 49.7793 50.9535L46.4166 54.1533C46.1728 54.3858 45.7775 54.3842 45.5354 54.1509L42.1458 50.8822C42.0003 50.742 41.92 50.5541 41.92 50.3544C41.92 50.1658 41.993 49.9849 42.1257 49.8469C42.2684 49.699 42.4621 49.6152 42.671 49.6136C42.8796 49.6112 43.0747 49.6904 43.2211 49.8352L45.1633 51.7716V46.2623C45.1633 45.8302 45.5219 45.48 45.9644 45.48C46.4067 45.48 46.7653 45.8302 46.7653 46.2623V51.7542L48.6338 49.8415C48.7777 49.695 48.9722 49.6136 49.1806 49.6128Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      d="M42.7232 55.0944H49.2267C49.6703 55.0944 50.0299 55.4135 50.0299 55.8073C50.0299 56.2009 49.6703 56.52 49.2267 56.52H42.7232C42.2796 56.52 41.92 56.2009 41.92 55.8073C41.92 55.4135 42.2796 55.0944 42.7232 55.0944Z"
    />
  </svg>
)
